import { useQuery } from "@apollo/client/react";
import { PublicStoreDocument } from "@/generated/graphql";
import { isGraphQLNotFound } from "@/lib/graphqlErrors";
import type { PublicCategory, PublicStore } from "@/types/models";

export function usePublicStore(slug: string | undefined) {
  const { data, loading, error, refetch } = useQuery(PublicStoreDocument, {
    variables: { slug: slug! },
    fetchPolicy: "cache-and-network",
    skip: !slug,
  });

  const store: PublicStore | null = data?.publicStore ?? null;
  const categories: PublicCategory[] = store?.categories ?? [];
  const notFound = !loading && (isGraphQLNotFound(error) || (!store && !!error));

  return {
    store,
    categories,
    loading,
    error,
    notFound,
    refetch,
  };
}
